module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "page-background-image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/page002.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "page002text1"
  }, [_vm._v("Text copyright © 2008 by Sylvia A. Rouss"), _c('br'), _vm._v("Illustrations copyright © 2008 by Katherine Janus Kahn")]), _vm._v(" "), _c('div', {
    staticClass: "page002text2"
  }, [_vm._v("All rights reserved. International copyright secured. No part of this book may be"), _c('br'), _vm._v("reproduced, stored in a retrieval system, or transmitted in any form or by any means—"), _c('br'), _vm._v("electronic, mechanical, photocopying, recording, or otherwise—without the written"), _c('br'), _vm._v("permission of Lerner Publishing Group, Inc., except for the inclusion of brief quotes in an"), _c('br'), _vm._v("acknowledged review.")]), _vm._v(" "), _c('div', {
    staticClass: "page002text3"
  }, [_vm._v("KAR-BEN PUBLISHING"), _c('br'), _vm._v("A division of Lerner Publishing Group, Inc."), _c('br'), _vm._v("241 First Avenue North"), _c('br'), _vm._v("Minneapolis, MN 55401 U.S.A."), _c('br'), _vm._v("1-800-4-Karben")]), _vm._v(" "), _c('div', {
    staticClass: "page002text4"
  }, [_vm._v("Website address: "), _c('a', {
    attrs: {
      "href": "http://www.karben.com",
      "target": "_blank"
    }
  }, [_vm._v("www.karben.com")])]), _vm._v(" "), _c('div', {
    staticClass: "page002text5"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('div', {
    staticClass: "page002text6"
  }, [_vm._v("Rouss, Sylvia A."), _c('br'), _c('span', {
    staticClass: "cpadd"
  }, [_vm._v("Sammy Spider’s first Shavuot / by Sylvia A. Rouss ; illustrated by Katherine"), _c('br'), _vm._v("Janus Kahn."), _c('br'), _c('span', {
    staticClass: "cpadd1"
  }, [_c('span', {
    staticClass: "ws20"
  }, [_vm._v("p. cm.")]), _c('br'), _c('span', {
    staticClass: "cpadd"
  }, [_vm._v("Summary: Sammy Spider lowers himself down on a strand of webbing to get a"), _c('br'), _vm._v("closer look at the Shapiro family’s preparations for Shavuot, a holiday celebrating"), _c('br'), _vm._v("the time when God gave the Torah to Moses. Includes a recipe for making blintzes."), _c('br'), _c('span', {
    staticClass: "cpadd"
  }, [_vm._v("ISBN: 978–0–8225–7224–4 (lib. bdg. : alk. paper)"), _c('br'), _c('span', {
    staticClass: "cpadd"
  }, [_c('span', {
    staticClass: "ws2"
  }, [_vm._v("[1. Shavuot—Fiction. 2. Spiders—Fiction.] I. Kahn, Katherine, ill. II. Title.")]), _c('br'), _vm._v("PZ7.R7622Saq 2008"), _c('br'), _vm._v("[E]—dc22")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page002text7"
  }, [_vm._v("2006039739")]), _vm._v(" "), _c('div', {
    staticClass: "page002text8"
  }, [_vm._v("Manufactured in the United States of America"), _c('br'), _vm._v("2 – MG – 10/1/12")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c09c297e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/page002.vue
// module id = 63
// module chunks = 0